import  storage from 'store'
import md5 from 'md5';
import { DEFAULT_LANGUAGE, normalizeLanguage } from '@/utils/language/common'
const TokenKey = 'Access-Token'
const TokenExpiresAtKey = 'Access-Token-Expires-At'
const TokenValidDuration = 7 * 24 * 60 * 60 * 1000
const LogoutEvent = 'viwoods-auth-logout'

const MachineModel = 'Machine-Model'
const MachineModelName = 'Machine-Model-Name'
const MachineNumber = 'Machine-Number'
const Language = 'Language'
const Dir = 'Dir'
const CurrentDir = 'CurrentDir'


export function setCurrentDir(val) {
  return storage.set(CurrentDir, val)
}




export function getCurrentDir() {
  return storage.get(CurrentDir)
}
export function setDir(val) {
  return storage.set(Dir, val)
}
// export function getDir() {
//   return storage.get(Dir)
// }
export function getDir(selfDir) {
  const urlParams = new URLSearchParams(window.location.search);
  const dirFromUrl = urlParams.get('apk');
  if (dirFromUrl) {
    return "/"+dirFromUrl+"/";
  }
  if (selfDir) {
    return selfDir;
  }
  return storage.get(Dir);
}
export function setMachineModel(val) {
  return storage.set(MachineModel, val)
}
export function setMachineModelName(val) {
  return storage.set(MachineModelName, val)
}
export function getMachineModel() {
  return storage.get(MachineModel)
}
export function getMachineModelName() {
  return storage.get(MachineModelName)
}


export function setMachineNumber(val) {
  return storage.set(MachineNumber, val)
}
// export function getMachineNumber() {
//   return storage.get(MachineNumber)
// }
export function getMachineNumber(selfSN) {
  const urlParams = new URLSearchParams(window.location.search);
  const snFromUrl = urlParams.get('sn');
  if (snFromUrl && snFromUrl!=="" && snFromUrl !==undefined)  {
    return snFromUrl;
  }
  if (selfSN && snFromUrl!=="" && snFromUrl !==undefined) {
    return selfSN;
  }
  return storage.get(MachineNumber);
}

export function setLanguage(val) {
  const language = normalizeLanguage(val)
  const result = storage.set(Language, language)
  if (typeof window !== 'undefined' && typeof window.dispatchEvent == 'function') {
    window.dispatchEvent(new CustomEvent('viwoods-language-change', { detail: { language } }))
  }
  return result
}
export function getLanguage() {
  return normalizeLanguage(storage.get(Language))
}

export function getToken() {
  const token = storage.get(TokenKey)
  if (!token) {
    storage.remove(TokenExpiresAtKey)
    return token
  }
  const expiresAt = Number(storage.get(TokenExpiresAtKey) || 0)
  if (!expiresAt) {
    refreshTokenExpiresAt()
    return token
  }
  if (expiresAt <= Date.now()) {
    removeToken()
    return ''
  }
  refreshTokenExpiresAt()
  return token
}

export function peekToken() {
  return storage.get(TokenKey) || ''
}

export function setToken(token) {
  if (!token) {
    return removeToken()
  }
  refreshTokenExpiresAt()
  return storage.set(TokenKey, token)
}



export function removeToken() {
  storage.remove(TokenExpiresAtKey)
  const result = storage.remove(TokenKey)
  if (typeof window !== 'undefined' && typeof window.dispatchEvent == 'function') {
    window.dispatchEvent(new CustomEvent(LogoutEvent))
  }
  return result
}

export function refreshTokenExpiresAt() {
  return storage.set(TokenExpiresAtKey, Date.now() + TokenValidDuration)
}

export function getApiHeader(inObject,uri,deviceId) {
  inObject.uri = "/" + uri
  var ll = getLanguage()
  if (!ll) {
    ll = DEFAULT_LANGUAGE
  }
  let machineNumber = getMachineNumber()
  if ((machineNumber==="" || machineNumber===null || machineNumber===undefined) && deviceId!=="" && deviceId!==null && deviceId!==undefined) {
    machineNumber= deviceId
  }
    return { 
      "System-Version": "1.0.0",
      "Source":"2",
      "Machine-Model": "web",
      "Machine-Number": machineNumber,
      "Language": ll, 
      'Sign': getSign(inObject,uri),
    }
}

function shouldSkipSignParam(uri, key) {
  if (key != "eTags") {
    return false
  }
  const normalizedUri = String(uri || '')
  return normalizedUri.includes("upload/complete")
    || normalizedUri.includes("upload/oss/complete")
}

export function getSign(inObject,uri) {
  var sorter = function (inObject) {
    var sortedJson = {};
    var sortedKeys = Object.keys(inObject).sort();
    for (var i = 0; i < sortedKeys.length; i++) {
        sortedJson[sortedKeys[i]] = inObject[sortedKeys[i]]
    }
    return sortedJson;
  }
  var sortedParam = sorter(inObject);
  var needSignatureStr = "";
  for (var key in sortedParam) {
      var value = sortedParam[key];
      if (shouldSkipSignParam(uri, key)) {
        continue
      }
      needSignatureStr = needSignatureStr + key + '=' + value + '&';
  }
  needSignatureStr = needSignatureStr.substring(0, needSignatureStr.length - 1)
  needSignatureStr +=  process.env.VUE_APP_API_SECRETKEY || 'O9EfpIx4g9o8TKuCv2n5msBHucSrAf';
  console.log("needSignatureStr", needSignatureStr)
  return  md5(needSignatureStr);
}
